module.exports = __webpack_public_path__ + "img/IMG_8981_L_Wood_MockedUp.2eaae7f2.jpg";